import ResetPassword from './ResetPassword'

export default ResetPassword
// eslint-disable-next-line import/export
export * from './ResetPassword'
